module.exports = __webpack_public_path__ + "img/back-disabled.cd7d0433.svg";